import { api } from './api';

export interface WorkspaceStateSubmission {
 entities: object[];
 responsibilities: Record<string, object>;
 relationships: object[];
 umlDiagram: object;
 codeFiles: Record<string, object[]>;
 activeLanguage: string;
 mode: 'learn' | 'practice' | 'interview';
 totalTimeSpent: number;
 timeSpentPerSection: Record<string, number>;
}

export interface EvaluationReport {
 id: string;
 problemId: string;
 mode: 'learn' | 'practice' | 'interview';
 requirementsCoverage: number;
 entityModeling: number;
 relationships: number;
 umlDesign: number;
 codeQuality: number;
 completeness: number;
 overallScore: number;
 /**
  * False when the problem carries no expected entities/relationships (e.g. custom
  * problems), in which case no numeric score is produced.
  */
 scoringAvailable?: boolean;
 timeBreakdown: Record<string, number>;
 comparison: {
  section: string;
  missing: string[];
  extra: string[];
  incorrect: string[];
 }[];
 totalTimeTaken: number;
 submittedAt: string;
 createdAt: string;
 updatedAt: string;
}

class LLDEvaluationService {
 /**
  * Submit workspace state for evaluation and generate a report.
  * Requires JWT authentication.
  */
 async submitEvaluation(problemId: string, workspaceState: WorkspaceStateSubmission): Promise<EvaluationReport> {
  return await api.post(`/lld-practice/evaluation/${problemId}`, workspaceState);
 }

 /**
  * Get existing evaluation report for a problem.
  * Returns null if no evaluation exists.
  * Requires JWT authentication.
  */
 async getEvaluation(problemId: string): Promise<EvaluationReport | null> {
  try {
   return await api.get(`/lld-practice/evaluation/${problemId}`);
  } catch (error: any) {
   if (error.status === 404) {
    return null;
   }
   throw error;
  }
 }
}

export const lldEvaluationService = new LLDEvaluationService();
export default lldEvaluationService;
